import { render, staticRenderFns } from "./AccountProvider.vue?vue&type=template&id=38462777"
import script from "./AccountProvider.vue?vue&type=script&lang=js"
export * from "./AccountProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports